/**
 * Conjunto mínimo de ícones em SVG inline.
 * Evita dependência de biblioteca de ícones e mantém o traço consistente
 * (stroke 1.6, currentColor) em todo o site.
 */

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

function Svg({ size = 18, children, className, ...rest }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const ArrowUpRight = (props) => (
  <Svg {...props}>
    <path {...stroke} d="M7 17 17 7M9 7h8v8" />
  </Svg>
);

export const ArrowRight = (props) => (
  <Svg {...props}>
    <path {...stroke} d="M4 12h15M13 6l6 6-6 6" />
  </Svg>
);

export const ArrowUp = (props) => (
  <Svg {...props}>
    <path {...stroke} d="M12 19V5M6 11l6-6 6 6" />
  </Svg>
);

export const Menu = (props) => (
  <Svg {...props}>
    <path {...stroke} d="M4 7h16M4 12h16M4 17h16" />
  </Svg>
);

export const Close = (props) => (
  <Svg {...props}>
    <path {...stroke} d="m6 6 12 12M18 6 6 18" />
  </Svg>
);

export const Sun = (props) => (
  <Svg {...props}>
    <circle {...stroke} cx="12" cy="12" r="4" />
    <path
      {...stroke}
      d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
    />
  </Svg>
);

export const Moon = (props) => (
  <Svg {...props}>
    <path {...stroke} d="M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5Z" />
  </Svg>
);

export const Mail = (props) => (
  <Svg {...props}>
    <rect {...stroke} x="3" y="5" width="18" height="14" rx="2.5" />
    <path {...stroke} d="m3.5 7 7.6 5.3a1.6 1.6 0 0 0 1.8 0L20.5 7" />
  </Svg>
);

export const Phone = (props) => (
  <Svg {...props}>
    <path
      {...stroke}
      d="M6.5 3.5h2.2l1.4 3.6-1.8 1.3a11.5 11.5 0 0 0 5.3 5.3l1.3-1.8 3.6 1.4v2.2a2 2 0 0 1-2.2 2A15.8 15.8 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2Z"
    />
  </Svg>
);

export const FileText = (props) => (
  <Svg {...props}>
    <path {...stroke} d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
    <path {...stroke} d="M14 3v5h5M9 13h6M9 17h4" />
  </Svg>
);

export const Github = (props) => (
  <Svg {...props}>
    <path
      fill="currentColor"
      d="M12 2a10 10 0 0 0-3.16 19.49c.5.09.68-.22.68-.48v-1.7c-2.78.6-3.37-1.34-3.37-1.34-.45-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.61.07-.61 1 .07 1.53 1.03 1.53 1.03.9 1.53 2.34 1.09 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.56-1.11-4.56-4.95 0-1.09.39-1.99 1.03-2.69-.1-.25-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.03a9.5 9.5 0 0 1 5 0c1.91-1.3 2.75-1.03 2.75-1.03.55 1.38.2 2.4.1 2.65.64.7 1.03 1.6 1.03 2.69 0 3.85-2.34 4.7-4.57 4.94.36.31.68.92.68 1.85v2.74c0 .27.18.58.69.48A10 10 0 0 0 12 2Z"
    />
  </Svg>
);

export const Linkedin = (props) => (
  <Svg {...props}>
    <path
      fill="currentColor"
      d="M4.98 3.5A2.5 2.5 0 1 0 5 8.5a2.5 2.5 0 0 0-.02-5ZM3 9.5h4V21H3V9.5Zm6.5 0h3.83v1.57h.05c.53-.95 1.83-1.95 3.77-1.95 4.03 0 4.78 2.5 4.78 5.76V21h-4v-5.28c0-1.26-.02-2.88-1.83-2.88-1.83 0-2.11 1.37-2.11 2.79V21h-4V9.5Z"
    />
  </Svg>
);

export const Whatsapp = (props) => (
  <Svg {...props}>
    <path
      fill="currentColor"
      d="M12.04 2A9.9 9.9 0 0 0 2.1 11.9c0 1.75.46 3.46 1.34 4.97L2 22l5.28-1.38a9.9 9.9 0 0 0 4.76 1.21h.01a9.9 9.9 0 0 0 9.9-9.9A9.9 9.9 0 0 0 12.04 2Zm5.8 14.1c-.24.68-1.4 1.3-1.94 1.35-.5.05-1.13.07-1.82-.11a15 15 0 0 1-1.65-.61c-2.9-1.25-4.8-4.17-4.94-4.36-.15-.2-1.19-1.58-1.19-3.01 0-1.43.75-2.14 1.02-2.43.27-.29.58-.36.78-.36l.56.01c.18 0 .42-.07.66.5.24.58.83 2.01.9 2.16.07.14.12.31.02.5-.1.2-.15.32-.29.49-.15.17-.31.38-.44.51-.15.14-.3.3-.13.59.17.29.76 1.25 1.63 2.02 1.12 1 2.06 1.31 2.35 1.46.29.14.46.12.63-.07.17-.2.73-.85.92-1.14.2-.29.39-.24.66-.15.27.1 1.7.8 1.99.95.29.14.48.22.55.34.07.12.07.68-.17 1.36Z"
    />
  </Svg>
);
